/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Dispatch, SetStateAction } from "react";
import { createCtx } from "~/tools";
import { ApplicationData } from "./types";

type Props = {
  applicationData?: ApplicationData;
  setApplicationData: Dispatch<SetStateAction<ApplicationData>>;
};

export const [useApplicationWizard, ApplicationWizardCtxProvider] =
  createCtx<Props>();
